import { render, staticRenderFns } from "./receiptNoteDetail.vue?vue&type=template&id=199d6612"
import script from "./receiptNoteDetail.vue?vue&type=script&lang=js"
export * from "./receiptNoteDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports